module.exports = [
  '>0.25%',
  'not op_mini all',
  'not dead',
  'Firefox ESR',
];
